export default __webpack_public_path__ + "static/media/savings.81f70ddf.svg";